unit SupplierItemListType;
{

/* Initial. */

}
interface

uses
  JS,
  SupplierItemType;

type
  TSupplierItemArray = array of TSupplierItemType;

  TSupplierItemListType = class
    fSupplierItemArray: TSupplierItemArray;
  public
    property SupplierItemArray: TSupplierItemArray read fSupplierItemArray;
    constructor Create(const String_JSON: String);
  end;

implementation

constructor TSupplierItemListType.Create(const String_JSON: String);
var JSArray_ListType: TJSArray;
    JSValue_Type: JSValue;
    SupplierItemType: TSupplierItemType;
begin
  if String_JSON <> 'null' then
  begin
    JSArray_ListType := TJSArray(TJSJSON.parseobject(String_JSON));

    for JSValue_Type in JSArray_ListType do
    begin
      SupplierItemType := TSupplierItemType.Create(TJSJSON.stringify(JSValue_Type));

      Insert(SupplierItemType, fSupplierItemArray, High(fSupplierItemArray));
    end;
  end;
end;

end.
